import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SITE_URL } from '../data/escritorio';

// Título, descrição e indexação da página; ao sair, volta ao que estava no index.html.
// noindex: páginas que o Google não deve guardar (ex.: "página não encontrada").
export const usePageMeta = ({ title, description, noindex = false }) => {
  useEffect(() => {
    const previousTitle = document.title;
    if (title) document.title = `${title} | Navarro & Vieira Advogados`;
    const meta = document.head.querySelector('meta[name="description"]');
    const previousDescription = meta?.getAttribute('content');
    if (meta && description) meta.setAttribute('content', description);
    const robots = document.head.querySelector('meta[name="robots"]');
    const previousRobots = robots?.getAttribute('content');
    if (robots && noindex) robots.setAttribute('content', 'noindex, follow');
    return () => {
      document.title = previousTitle;
      if (meta && previousDescription) meta.setAttribute('content', previousDescription);
      if (robots && previousRobots) robots.setAttribute('content', previousRobots);
    };
  }, [title, description, noindex]);
};

// Mantém o <link rel="canonical"> do index.html igual ao endereço da página atual (sem # e sem ?).
export const CanonicalUrl = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const link = document.head.querySelector('link[rel="canonical"]');
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : '/';
    if (link) link.setAttribute('href', `${SITE_URL}${path}`);
  }, [pathname]);
  return null;
};

// Marcação estruturada (schema.org) para o Google. "<" é escapado para não fechar o <script>.
export const JsonLd = ({ data }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, '\\u003c') }}
  />
);
